import { InPlaceDatePickerEditor } from "@etframework/ui.components";
import moment from "moment";
import { forwardRef, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useSystemPreferences } from "../../data/queries/systemPreferencesQueries";
import Enums from "../../types/enums";

export const DateEditor = forwardRef(
  (
    {
      id,
      inlineActionSuccess,
      task,
      canModifyTasks,
      value,
      model = {},
      isDueDate = false,
      ...rest
    },
    ref
  ) => {
    const { i18n } = useTranslation(["Overlay"]);
    const { data: systemPreferences, isPending } = useSystemPreferences();
    const className = useMemo(() => {
      let cls = "date-editor-input";

      if (isDueDate && value) {
        const today = moment.utc(new Date());
        const dueDate = moment.utc(value);

        if (
          dueDate < today &&
          task?.Stage?.StageType !== Enums.StageType.Completed
        ) {
          cls = "overdue-date";
        } else {
          const rangeStart = dueDate
            ?.clone()
            ?.subtract(systemPreferences?.TaskApproachingDaysPrior, "days");

          const isInRange = today?.isBetween(rangeStart, dueDate, "day", "[]");

          if (isInRange) cls = "approaching-date";
        }
      }

      return cls;
    }, [isDueDate, value, systemPreferences]);

    if (isPending) return null;

    return (
      <div className="date-editor d-flex justify-content-start align-items-center">
        <InPlaceDatePickerEditor
          ref={ref}
          id={id}
          submitClick={inlineActionSuccess}
          model={{ showClearButton: false, ...model }}
          value={value ? moment.utc(value).toDate() : null}
          disabled={!canModifyTasks}
          language={i18n.language}
          actionOnBlur={"Cancel"}
          className={className}
          {...rest}
        />
      </div>
    );
  }
);
